<template>
  <footer :class="['landing-footer', 'fullWidth', variant]">
    <div class="footer-inner">
      <p class="copyright smallerText">&copy; {{ currentYear }} Unit</p>
      <a class="footer-link smallerText" @click="handleLinkClick" v-haptic>{{ linkText }}</a>
    </div>
  </footer>
</template>

<script>
import { useRouter } from "vue-router";

export default {
  name: "LandingFooter",
  props: {
    variant: {
      type: String,
      default: "landing", // "landing" | "about"
    },
  },
  setup(props) {
    const router = useRouter();
    const currentYear = new Date().getFullYear();

    const linkText =
      props.variant === "about"
        ? "Back to Home"
        : "Learn more about Unit\u2019s unique exchange rate and monetary ecosystem";

    const handleLinkClick = () => {
      if (props.variant === "about") {
        router.push("/");
      } else {
        router.push("/about");
      }
    };

    return { currentYear, linkText, handleLinkClick };
  },
};
</script>

<style scoped>
.landing-footer {
  position: relative;
  padding: var(--space-5);
  width: 100%;
}

.landing-footer.landing {
  margin-bottom: calc(-1 * (var(--control-height-default) + 8 * var(--space-5)));
}

.footer-inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: var(--space-5);
}

.footer-link {
  color: var(--color-text-tertiary);
  text-decoration: none;
  cursor: pointer;
  transition: color 0.15s;
  text-align: right;
  margin-left: auto;
}

.footer-link:hover {
  color: var(--color-text-primary);
}

.copyright {
  color: var(--color-text-muted);
  margin: 0;
  white-space: nowrap;
}

@media only screen and (max-width: 480px) {
  .footer-inner {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--space-3);
  }
}
</style>
